module.exports = __webpack_public_path__ + "static/media/file_type_ppt.967b5368.svg";